import BaseComponent from '../base/baseComponent';
export default class MyAccountMenuComponent extends BaseComponent {
    constructor(element) {
        super(element);
        this.toggleMenu = (e) => {
            e.preventDefault();
            const expanded = this.$el.dataset.expanded == 'true';
            this.$el.dataset.expanded = `${!expanded}`;
        };
        this.isMobile = window.isMobile();
        this.activePage = this.$el.querySelector(this.SELECTORS.activePage);
        if (this.isMobile) {
            this.initMenuMobile();
        }
    }
    get Messages() {
        return {
            [this.CUSTOM_MESSAGES.BREAKPOINTER.BREAKPOINT_CHANGE]: this.onBreakpointChange,
        };
    }
    get SELECTORS() {
        return {
            activePage: '.selected a',
        };
    }
    initMenuMobile() {
        if (this.activePage) {
            this.activePage.addEventListener('click', this.toggleMenu);
        }
    }
    onBreakpointChange(br) {
        if (window.isMobile() && !this.isMobile) {
            this.isMobile = true;
            this.initMenuMobile();
        }
        else if (window.isDesktop()) {
            this.isMobile = false;
            if (this.activePage) {
                this.activePage.removeEventListener('click', this.toggleMenu);
            }
        }
    }
}
